import React from 'react';
import ServicePageTemplate from './ServicePageTemplate';
import { mobileAppDevelopmentServicesConfig } from './servicePageConfigs';

const MobileAppDevelopmentServices = () => (
  <ServicePageTemplate {...mobileAppDevelopmentServicesConfig} />
);

export default MobileAppDevelopmentServices;
